import React from 'react';
import styled from "styled-components";



const AgenciaMarketing = () => {
    return ( 
        <Div>
           <h2>impulsa marketing</h2>
           <p>Somos una Agencia de Marketing Digital, expertos en Marketing e Ecommerce nuestra misión es trabajar en conjunto y planificar estrategias acordes a los objetivos empresariales de cada uno de nuestros clientes.</p> 
           <h2>Mision</h2>
           <p>Desarrollar soluciones integrales de tecnología, diseño y marketing digital que impulsen a nuestros clientes a posicionar, difundir y promover sus marcas, productos y servicios</p>
        </Div>
     );
}
 
export default AgenciaMarketing;


const Div = styled.div`
width: 50%;
padding: 20px;
width: 50%;
padding: 20px;
display: flex;
flex-direction: column;
align-items: center;


h2{
    text-transform: uppercase;
    letter-spacing: 0.3em;
    text-align: center;
    color: #E63946;
}

p{
    letter-spacing: 0.25em;
    text-align: center;
}






`


